import React from 'react';
import PropTypes from 'prop-types';

const Phone = (props) => {
  if (!props.phoneNumber) {
    return null;
  }

  return (
    <a className="phone" href={`call:${props.phoneNumber}`}
        onClick={() => {
            if (props.isQuickInfo) {
                window.wts.push(['send', 'click', {linkId: 'Karte.Telefonnummer'}]); //bei Klick auf Telefonnummer
            }
            else {
                window.wts.push(['send', 'click', {linkId: 'Telefonnummer'}]);
            }
            return true;
        }}
    >
      <div className="halflings halflings-earphone"></div>
      {' '} <span>{props.phoneNumber}</span>
    </a>
  );
}

Phone.propTypes = {
    phoneNumber: PropTypes.string
};

export default Phone;
